import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { getPostTypeForTracking } from 'src/app/pages/starterDashboardV2/shared/components';
import type { EnrichedReadyToSharePlatformPostV2 } from 'src/app/shared/api/readyToShare';

const PRE_MADE_POST_MODULE_CLICK_EVENT_NAME = 'petition_manage_ready_to_share_posts_click_v2_pre_drafted';

type UseClickTrackingParams = {
	selectedTab: string;
};

type UseClickTrackingResult = {
	trackClick: (post: EnrichedReadyToSharePlatformPostV2) => void;
};

export function useClickTracking({ selectedTab }: UseClickTrackingParams): UseClickTrackingResult {
	const track = useTracking();

	const trackClick = useCallback(
		(post: EnrichedReadyToSharePlatformPostV2) => {
			void track(PRE_MADE_POST_MODULE_CLICK_EVENT_NAME, {
				context: 'petition_dashboard_ready_to_share_post',
				view_context: selectedTab,
				location: getPostTypeForTracking(post),
			});
		},
		[track, selectedTab],
	);

	return {
		trackClick,
	};
}
